import { useEffect, useState } from "react";
import DashboardLayout from '../Layout/Index'
import TransactionsTable from '../components/tables/TransactionsTable'
import TransactionDetails from '../Modals/TransactionDetails'
import { FiSearch } from "react-icons/fi";
import FormatePrice from '../utils/FormatePrice';
import { useDispatch, useSelector } from "react-redux";
import { fetchTransactions } from "../redux/slices/transactionSlice";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { SelectDropDown } from "../components/SelectDropdown";

const TransactionHistory = () => {
  const [status, setStatus] = useState(1);
  const [paymentStatus, setPaymentStatus] = useState(null); 
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const itemsPerPage = 10;
  
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [date, setDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); 
  const [totalRecord, setTotalRecord] = useState(0); 

  const transaction = useSelector((state) => state.transaction); 
  const overview = useSelector((state) => state.overview)
  const overviewData = overview?.overview?.data

  useEffect(() =>{
    dispatch(
      fetchTransactions({
      paymentStatus: paymentStatus,
      date: date,
      searchText: searchTerm,
      pageSize: itemsPerPage,
      pageNumber: currentPage,

    }))
  }, [dispatch, searchTerm, currentPage, date, paymentStatus]);

  const SelectedOption = [
    { label: "Pending", value: "1" },
    { label: "Initiated", value: "2" },
    { label: "Successful", value: "3" },
    { label: "Failed", value: "4" },
  ];

  const SelectedOptionPayment = [
    { label: "All", value: "1" },
    { label: "Initiated", value: "2" },
    { label: "Successful", value: "3" },
    { label: "Failed", value: "4" },
  ];

  useEffect(() => {
    if(transaction){
      setTotalRecord(transaction?.transaction?.totalRecord);
    }
  },[transaction]);

  const data = transaction?.transaction?.data;

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setIsDrawerOpen(true);
  };

  const changeStatus = (selectedOption) => {
    setStatus(selectedOption.value);
  }
  const changePaymentType = (selectedOption) => {
    setPaymentStatus(selectedOption.value);
  }
  return (
    <DashboardLayout>
      <div className="px-6 sm:px-8 pt-5 py-10 bg-white w-full mt-16">
        <div className="bg-white px-2 py-3 flex flex-col md:flex-row md:items-center justify-center gap-10">
          <div>
            <div className="flex items-center justify-between mb-6 md:mb-0">
              <h1 className="text-xl sm:text-2xl font-bold text-[#FF0000] pb-2">Transaction History</h1>
              <div className="md:hidden flex whitespace-nowrap flex-col py-2 px-4 rounded-md bg-orange">
                <p className="text-xs text-center">Available Balance</p>
                <h2 className="text-sm font-bold text-center">{FormatePrice(overviewData?.totalSalesAmount)}</h2>
              </div>
            </div>
            <p className="text-sm">
            Discover valuable feedback from customers to enhance service quality. Track ratings for delivery agents and popular dishes to keep our standards high and customers satisfied.</p>
          </div>
          <div className="hidden md:block whitespace-nowrap gap-2 py-3 px-4 rounded-md bg-orange">
            <p className="text-xs text-center">Available Balance</p>
            <h2 className="text-xl font-bold text-center">{FormatePrice(overviewData?.totalSalesAmount)}</h2>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row lg:items-center justify-between px-4 py-6 bg-white shadow-xl mb-6">
          <div className="relative">
            <input
              type="search"
              name="search"
              placeholder="Search by date, status"
              className="bg-[#F9F9F9] px-12 py-2 rounded-2xl w-full md:w-[350px] ring-0 outline-none text-xs placeholder:text-xs"
            />
            <FiSearch className="absolute left-4 top-2 text-lg text-[#F9F9F9F]" />
          </div>
          <div className="flex items-center flex-wrap md:flex-nowrap justify-between gap-5 mt-5 lg:mt-0">
            <div className="flex items-center">
              <p className="text-xs lg:text-sm pr-2">Status </p>
              <SelectDropDown options={SelectedOption} onSelect={changeStatus} />
            </div>
            <div className="flex items-center">
              <p className="text-xs xl:text-sm pr-2">Trasaction Type </p>
              <SelectDropDown options={SelectedOptionPayment} onSelect={changePaymentType} />
            </div>
            <div className="flex items-center">
              <p className="text-xs xl:text-sm pr-2">Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={date}
                  onChange={(newValue) => setDate(newValue)}
                />
              </LocalizationProvider>
            </div>
          </div>
        </div>
        <TransactionsTable 
          onRowClick={handleRowClick}
          searchTerm={searchTerm} 
          data={data} 
          itemsPerPage={itemsPerPage} 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={transaction?.loading}
          totalRecord={totalRecord}
        />
        <TransactionDetails
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          id={selectedItem}
        />
      </div>
    </DashboardLayout>
  )
}

export default TransactionHistory